konnyScript(function($){
    //이벤트 주의사항 여닫기
    $('.knEventWrap .notiBox .notiTit').click(function(){
        var notiBox = $(this).parent('.notiBox');
        if(notiBox.hasClass('on')){
          notiBox.removeClass('on');
        }else{
          notiBox.addClass('on');
        }
    });

    //이벤트용 슬라이드
    var eventSwiper = new Swiper("#kn_event_swiper_slide1", {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: '2.9%',
        scrollbar: {
            el:'#kn_event_swiper_slide1 .swiper-scrollbar',
        },
        pagination: {
            el:'#kn_event_swiper_slide1 .swiper-pagination',
        },
        speed:2000,
        autoplay: {
          delay: 1000,
          disableOnInteraction: false,
        },
    });
    var eventSwiper = new Swiper("#kn_event_swiper_slide2", {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: '4.4%',
        scrollbar: {
            el:'#kn_event_swiper_slide2 .swiper-scrollbar',
        },
        pagination: {
            el:'#kn_event_swiper_slide2 .swiper-pagination',
        },
    });

    //이벤트 탭 슬라이드
    var knEventNavSlide = new Swiper("#e_nav_swiper_slide1", {
        slidesPerView:'auto',
        grabCursor:true,
        centeredSlides:false,
    });

    //이벤트 탭 스크롤
    (function () {
    	const $tabs = $('.knEventWrap .navWrap li');
    	const sections = [...Array(6)].map((_, i) => $('#eventCon' + (i + 1)));//이벤트 탭 a개 -> Array(a)
    	const isMobile = () => $(window).width() <= 750;
    
    	let isFromClick = false;
    	let clickTimeout;
    
    	$('#e_nav_swiper_slide1 a').on('click', function (e) {
    		e.preventDefault();
    		const $li = $(this).closest('li');
    		const index = $li.index();
    
    		clearTimeout(clickTimeout);
    		isFromClick = true;
    		clickTimeout = setTimeout(() => { isFromClick = false; }, 600);
    
    		$li.addClass('on').siblings().removeClass('on');
    		knEventNavSlide.slideTo(index);
    
    		const headerHeight = $('#header').outerHeight() || 0;
    		const eNavHeight = $('.knEventWrap .navWrap').outerHeight() || 0;
    		const fixHeight = headerHeight + eNavHeight;
    		const targetSection = $('#eventCon' + (index + 1));
    
            if (targetSection.length) {
            	const targetTop = targetSection.offset().top - fixHeight + 50;
            
            	$('.knEventWrap .navWrap').addClass('fixed');
            
            	if (window.scrollY === 0) {
            		window.scrollTo({ top: 1 });
            		setTimeout(() => {
            			window.scrollTo({ top: targetTop });
            		}, 20);
            	} else {
            		window.scrollTo({ top: targetTop });
            	}
            }
    
    		if (isMobile()) {
    			const container = knEventNavSlide.el;
    			const containerWidth = $(container).width();
    			const wrapper = $(container).find('.swiper-wrapper');
    			const slideOffset = $li.position().left;
    			const slideWidth = $li.outerWidth(true);
    			const totalSlides = $tabs.length;
    			let scrollX = 0;
    
    			if (index <= 1) {
    				scrollX = 0;
    			} else if (index >= 2 && index <= 4) {//이벤트 탭 활성화 시 가운데 정렬 (a번째 탭부터 b번째 탭까지)
    				scrollX = slideOffset - (containerWidth / 2) + (slideWidth / 2);
    			} else {
    				const $last = $tabs.last();
    				const lastOffset = $last.position().left;
    				const lastWidth = $last.outerWidth(true);
    				scrollX = (lastOffset + lastWidth) - containerWidth;
    			}
    			wrapper.css({
                	'transform': `translate3d(${-scrollX}px, 0, 0)`,
                	'transition': 'transform 0.3s ease'
                });
    		}
    	});
    
    	$(window).on('load scroll', function () {
    		if (!$('.knEventWrap .navWrap').length || isFromClick) return;
    
    		const headerHeight = $('#header').outerHeight() || 0;
    		const eNavHeight = $('.knEventWrap .navWrap').outerHeight() || 0;
    		const fixHeight = headerHeight + eNavHeight;
    		const winTop = $(window).scrollTop();
    		const eNavTop = $('.knEventWrap .navArea').offset().top - eNavHeight;
    
    		let activeIndex = 0;
    
    		for (let i = sections.length - 1; i >= 0; i--) {
    			if (winTop > sections[i].offset().top - fixHeight) {
    				activeIndex = i;
    				break;
    			}
    		}
    
    		if (winTop > eNavTop) {
    			$('.knEventWrap .navWrap').addClass('fixed');
    		} else {
    			$('.knEventWrap .navWrap').removeClass('fixed');
    		}
    
    		const $activeTab = $tabs.eq(activeIndex);
    		$activeTab.addClass('on').siblings().removeClass('on');
    		knEventNavSlide.slideTo(activeIndex, 120);
    
    		if (isMobile()) {
    			const container = knEventNavSlide.el;
    			const containerWidth = $(container).width();
    			const wrapper = $(container).find('.swiper-wrapper');
    			const slideOffset = $activeTab.position().left;
    			const slideWidth = $activeTab.outerWidth(true);
    			const totalSlides = $tabs.length;
    			let scrollX = 0;
    
    			if(activeIndex <= 1){
    				scrollX = 0;
    			}else if(activeIndex >= 2 && activeIndex <= 4){//이벤트 탭 활성화 시 가운데 정렬 (a번째 탭부터 b번째 탭까지)
    				scrollX = slideOffset - (containerWidth / 2) + (slideWidth / 2);
    			}else{
    				const $last = $tabs.last();
    				const lastOffset = $last.position().left;
    				const lastWidth = $last.outerWidth(true);
    				scrollX = (lastOffset + lastWidth) - containerWidth;
    			}
    			wrapper.css('transform', `translate3d(${-scrollX}px, 0, 0)`);
    		}
    	});
    })();

}) 